import { ICON__play_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { use_generation_current_price } from '@/hooks/use_generation_current_price';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { HOOK_GENERATION__start } from '@/pages/page_generation/view_header/_buttons/button_generation/_hooks/HOOK_GENERATION__start';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';
import { G_VIEW_generation_price_determining } from '../_views/G_VIEW_generation_price_determining';

export function G_BUTTON__generation_start() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { generation_current } = use_slice_generation(['generation_current']);

  const component_id = `${ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_START}_${generation_current._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_GENERATION);

  const { generation_current_price } = use_generation_current_price(true);

  /*
   * STATE
   */

  const { generation_start, can_start_generation } = HOOK_GENERATION__start();

  /*
   * EFFECTS
   */

  /*
   * HTML
   */

  if (Number.isNaN(generation_current_price)) return <G_VIEW_generation_price_determining />;

  if (generation_current.tool.graph.invocation_grid2d_view.image_out.meta.field_hash__value_full.is_empty_hash_sha256()) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return (
    <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.GENERATION_START]}>
      <UI_PRIMITIVE__button
        disabled={!can_start_generation}
        {...{ notifier }}
        onClick={() => void generation_start(false)}
        size="full"
        variant={'no-border-on-component'}
      >
        <ICON__play_solid className="size-5 text-purchase" />
      </UI_PRIMITIVE__button>
    </ViewShortcutTrigger>
  );
}
